import React, { useContext, useEffect, useState } from 'react'
import PageHeader from '../components/PageHeader';
import ProcedureItem from '../components/ProcedureItem';
import Sorters from '../components/Sorters';
import Pager from '../components/Pager';
import Loading from '../components/Loading';
import useDocumentTitle from '../components/useDocumentTitle';

import MyProceduresContext from '../context/ProceduresContext';
import MyProcedureClassesContext from '../context/ProcedureClassesContext';
import ProcedureButton from '../components/ProcedureButton';
import DropDownProcedureClasses from '../components/DropDownProcedureClasses';

const Procedures = () => {
    useDocumentTitle("Trámites y Productos");
    const { useProcedures, maxPage, procedureClassId, setPage, setProcedureTypeId, procedureTypeId, setProcedureClassId } = useContext(MyProceduresContext);
    const { procedures, isError, isLoading } = useProcedures();
    const { getProcedureClasses, procedureClasses, error, loading } = useContext(MyProcedureClassesContext);


    const [open, setOpen] = useState(-1);

    const handleOpen = (value, procedureClassId) => {
        setProcedureClassId(procedureClassId);
        setOpen(open === value ? -1 : value);
    };

    useEffect(() => {
        const letter = (procedureTypeId === 1 ? "T" : "P");
        setProcedureClassId(letter + "1");
        getProcedureClasses(letter);
    }, [procedureTypeId])

    return (
        <>
            <PageHeader tittle="TRÁMITES Y PRODUCTOS" />
            <div className='px-3'>
                <div className='flex flex-row sm:w-[40%] p-3 mx-auto mt-2 justify-around'>
                    <ProcedureButton onClick={() => { setPage(0); setOpen(-1); setProcedureTypeId(1) }} text="Trámites" background={procedureTypeId === 1 ? " bg-radialProcedureHover" : " bg-radialProcedure"} />
                    <ProcedureButton onClick={() => { setPage(0); setOpen(-1); setProcedureTypeId(2) }} text="Productos" background={procedureTypeId === 2 ? " bg-radialProcedureHover" : " bg-radialProcedure"} />
                </div>
                {loading ? <Loading isLoading={loading} /> :

                    !error.error ? procedureClasses && procedureClasses.length > 1 ? procedureClasses.map((procedureClass, index) => (
                        <DropDownProcedureClasses key={index} title={procedureClass.procedureClassName} index={index} handleOpen={(value) => {handleOpen(value, procedureClass.procedureClassId)}} open={open} />
                    )) : <h1 className='text-center w-full font-light mb-4'>No hay registros para mostrar</h1> : <h1 className='text-center text-red-500 w-full mb-4'>{error.message}</h1>
                }

            </div>
        </>
    );
}

export default Procedures;